import React from 'react';
type PendingNoteProps = {
  children: React.ReactNode;
  className?: string;
};

/* Visible draft marker for commercial data that hasn't been provided yet. */
export function PendingNote({
  children,
  className = ''
}: PendingNoteProps) {
  return <span className={`inline-flex items-center gap-1.5 rounded-md border border-dashed border-teal/70 bg-mint px-2.5 py-1 text-xs font-bold text-teal ${className}`} data-id="element-239" data-mp="o4fu6zdiyp6t">
      <span className="uppercase tracking-[.12em]" data-id="element-240" data-mp="3shcqjj2o3wht">Pending</span>
      <span className="font-medium text-petrol" data-id="element-241" data-mp="3ni006ocl87ah">· {children}</span>
    </span>;
}